import { evenlyItems } from "../../../helpers"
import { Chart } from "../../../models/charts/chart"
import { GraphDataObject } from "../../data-object/graph"
import { SeriesDO } from "../../data-object/graph"
import { seriesFromDataObject } from "./series-do.transforms"

export const chartFromGraphDataObject = (chart: Chart, graph: GraphDataObject): Chart => {
    chart.description = graph.description
    const colors = evenlyItems(chart.seriesColors, graph.series.length)
    chart.series = graph.series
        .sort((a, b) => {
            const maxA = a.raw_data.reduce((max, point) => Math.max(max, point.value), 0);
            const maxB = b.raw_data.reduce((max, point) => Math.max(max, point.value), 0);
            return maxB - maxA; 
        })
        .map((s, i) => seriesFromDataObject(
            s, 
            typeof colors[i] === 'object' ? { ...colors[i] } : {}
        ));
    chart.source = graph.source
    return chart
}